<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ brokerName }}</span>
		<app-button
			(click)="onCreateBrokerClick()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateAgentButton"
			>Create agent</app-button
		>
	</div>
</ng-template>

<ng-template #brokerTemplate let-item>
	<div class="flex items-center" [testHook]="testHooks.BrokerItemDiv">
		<div
			class="w-10 h-10 bg-grey-lighter rounded-md flex justify-center items-center text-sm"
		>
			{{ item.firstName[0] | uppercase }} {{ item.lastName[0] | uppercase }}
		</div>
		<div class="ml-2 font-bold whitespace-nowrap">
			{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}
		</div>
	</div>
</ng-template>

<app-member-card
	*ngIf="brokerage?.broker"
	[firstName]="brokerage?.broker?.firstName"
	[lastName]="brokerage?.broker?.lastName"
	[email]="brokerage?.broker?.email"
	[phone]="brokerage?.broker?.phoneNumber"
	member="BROKER"
	memberType="Agent"
	[hoverShadow]="hoverShadow"
	(dropdown)="brokerDropdownOptionSelect($event)"
	[skeletonLoading]="skeletonLoading"
	[testHook]="testHooks.MemberCard"
>
</app-member-card>

<app-auto-complete
	*ngIf="!brokerage?.broker"
	[label]="label"
	(onSelect)="setBroker($event)"
	placeholder="Search Agent"
	[itemGroups]="[
		{ items: [{ value: 'createNew' }], template: createNewTemplate },
		{
			items: searchResult,
			template: brokerTemplate,
			title: 'Agents',
			noResultsMessage: 'No brokers found',
		},
	]"
	[(ngModel)]="brokerName"
	name="dual-dropdown-1"
	(debounce)="searchBrokers($event)"
	[minSearchTerm]="2"
	[loading]="loading"
	[orientation]="orientation"
	[skeletonLoading]="skeletonLoading"
	[testHook]="testHooks.BrokerSearchAutoComplete"
>
</app-auto-complete>
